import React from 'react'
import { splitHighlight } from '../utils/search'

const Highlight = ({ text, query }) => (
  <>
    {splitHighlight(text, query).map((part, index) =>
      part.match
        ? <mark key={index} className="search-highlight">{part.text}</mark>
        : <React.Fragment key={index}>{part.text}</React.Fragment>
    )}
  </>
)

export default Highlight
